import { addressesMatch } from './addressNormalization'

type Address = {
  street?: string | null
  apt?: string | null
  city?: string | null
  state?: string | null
  zipCode?: string | null
}

export function selectCurrentAddress<T extends { id?: number; type?: string }>(
  addresses: T[] = []
): T | undefined {
  let latest: T | undefined
  for (const address of addresses ?? []) {
    if (address?.type?.toLowerCase() !== 'current') continue
    if (!latest || (address.id ?? 0) > (latest.id ?? 0)) latest = address
  }
  return latest
}

export function getFigureAddressError({
  isCurrentAddress,
  propertyUse,
  subjectAddress,
  currentAddress,
}: {
  isCurrentAddress?: boolean | null
  propertyUse?: string | null
  subjectAddress: Address
  currentAddress?: Address
}): string | null {
  if (isCurrentAddress === false) {
    if (
      !currentAddress ||
      ![
        currentAddress.street,
        currentAddress.city,
        currentAddress.state,
        currentAddress.zipCode,
      ].every(Boolean)
    ) {
      return 'Please enter your current home address before continuing.'
    }
    if (
      addressesMatch(subjectAddress, currentAddress) &&
      normalizeUnit(subjectAddress.apt) === normalizeUnit(currentAddress.apt)
    ) {
      return 'Your current home address matches the property address. Please confirm whether you live at this property.'
    }
  }

  if (
    (isCurrentAddress === false && propertyUse === 'PrimaryResidence') ||
    (isCurrentAddress === true &&
      ['SecondaryOrVacation', 'InvestmentOrRental'].includes(propertyUse))
  ) {
    return 'Please confirm whether you live at this property and how you use it. Your answers must agree.'
  }
  return null
}

function normalizeUnit(unit?: string | null): string {
  return (unit ?? '')
    .trim()
    .toUpperCase()
    .replace(/\s+/g, ' ')
    .replace(/^(?:APARTMENT|APT|UNIT)\b\.?\s*/, '')
    .replace(/^#\s*/, '')
}
